export default function getCentroid([top, right, bottom, left]) {
	return [top + (bottom - top) / 2, right + (left - right) / 2];
}
